/**
 * Filters queries
 */

import gql from 'graphql-tag'

export const categoriesQuery = gql`
  query GetCategories {
    genders {
      id
      name: gender
    }
    sports(navbarSports: true, withCategories: true) {
      id
      name
      route
      categories {
        id
        name
      }
    }
  }
`



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/MobileMenu/data.ts